/** A saved admin return belongs only to an authenticated administrator. */
export function loginRedirect(value: string | null, fallback: string, roles?: string[]): string {
  if (!value) return fallback;
  const path = value.startsWith("/") ? value : `/${value}`;
  if (path.startsWith("//") || /[\\\s]/.test(path)) return fallback;
  const route = path.split(/[?#]/, 1)[0].toLowerCase();
  if (route === "/register" || ((route === "/admin" || route.startsWith("/admin/")) && !roles?.includes("admin"))) return fallback;
  return path;
}
